/**
 * Hook de datos del **detalle de una orden** (`GET /api/v1/orders/<id>`).
 *
 * Datos de servidor -> TanStack Query. Solo se pide cuando hay un `id` activo
 * (`enabled`), p. ej. al abrir el modal de detalle: así la query no se dispara
 * con el modal cerrado. La key se segmenta por sede activa para no mezclar el
 * detalle entre sedes.
 */
import { useQuery } from "@tanstack/react-query";

import { getActiveSedeId } from "@/lib/sede";

import { fetchOrder } from "../api";
import type { OrderDetail } from "../types";
import { orderDetailQueryKey } from "./queryKeys";

/** Carga el detalle de la orden `id`. Con `id === null` la query queda inactiva. */
export function useOrder(id: number | null) {
  const sedeId = getActiveSedeId();
  return useQuery<OrderDetail>({
    queryKey: orderDetailQueryKey(sedeId, id ?? 0),
    queryFn: () => fetchOrder(id as number),
    enabled: id !== null,
    staleTime: 15_000,
  });
}
